import React, { useState, useEffect } from "react";
import { IoIosCall } from "react-icons/io";
import { useNavigate, useLocation } from "react-router-dom";
import img from "../../assets/Group 627709.svg";
import { storageService } from '../../domain/services/StorageService.js';
import { config } from '../../services/config.js';

const StickyNavHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [sampadaUrl, setSampadaUrl] = useState('https://sampada.kaha.com.np/');

  // Check if user is logged in
  const isLoggedIn = storageService.hasAuthToken();

  // Hide header only on MyBusinesses and EditBusiness pages
  const hideHeader = isLoggedIn && (location.pathname === '/my-businesses' || location.pathname.startsWith('/edit-business/'));

  // Get the current URL parameters to preserve them for Sampada redirection
  React.useEffect(() => {
    const currentUrl = new URL(window.location.href);
    const searchParams = currentUrl.searchParams;

    console.log('Current URL:', window.location.href);
    console.log('Search Params:', searchParams.toString());

    // If there are specific parameters like id, linkId, and action=profile
    if (searchParams.has('id') && searchParams.has('action') && searchParams.get('action') === 'profile') {
      // Preserve all current parameters and redirect to sampada with them
      const params = new URLSearchParams(searchParams);
      const newUrl = `https://sampada.kaha.com.np/?${params.toString()}`;
      console.log('Setting Sampada URL to:', newUrl);
      setSampadaUrl(newUrl);
    } else {
      console.log('Using default Sampada URL: https://sampada.kaha.com.np/');
    }
  }, []);

  const handleNavigation = (path) => {
    navigate(path);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      {/* Only show header if not on MyBusinesses or EditBusiness pages */}
      {!hideHeader && (
        <>
          {/* Desktop Header */}
          <div className="hidden sm:block sticky top-0 z-50 bg-gradient-to-r from-black/80 via-black/60 to-black/80 backdrop-blur-xl border-b border-white/20 shadow-2xl transition-all duration-500 hover:shadow-3xl">
            <div className="max-w-7xl mx-auto px-6 py-4">
              <div className="flex justify-between items-center">
                {/* Logo and Brand */}
                <div className="flex items-center gap-4 cursor-pointer" onClick={() => navigate('/')}>
                  <div className="w-16 h-16">
                    <img src={img} alt="kahaLogo" className="w-full h-full object-contain" />
                  </div>
                  <div>
                    <div className="text-[#16A951] font-bold text-2xl lg:text-3xl leading-tight">
                      KAHA
                    </div>
                    <div className="text-white/70 text-sm">
                      Location Tagging Solution
                    </div>
                  </div>
                </div>

                {/* Navigation Menu */}
                <div className="flex items-center gap-1">
                  <button
                    className="relative text-white/90 hover:text-white px-5 py-2.5 rounded-xl text-sm font-medium transition-all duration-300 hover:bg-white/10 hover:scale-105 hover:shadow-lg border border-transparent hover:border-white/30 overflow-hidden group"
                    onClick={() => {
                      navigate("/about-us");
                      setTimeout(() => {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                      }, 100);
                    }}
                  >
                    <span className="relative z-10">About Us</span>
                    <div className="absolute inset-0 bg-gradient-to-r from-green-500/20 to-green-600/20 transform -skew-x-12 -translate-x-full group-hover:translate-x-0 transition-transform duration-500"></div>
                  </button>

                  <a
                    href={sampadaUrl}
                    target="_self"
                    rel="noopener"
                    className="relative text-white/90 hover:text-white px-5 py-2.5 rounded-xl text-sm font-medium transition-all duration-300 hover:bg-white/10 hover:scale-105 hover:shadow-lg border border-transparent hover:border-white/30 overflow-hidden group inline-block"
                  >
                    <span className="relative z-10">Sampada</span>
                    <div className="absolute inset-0 bg-gradient-to-r from-green-500/20 to-green-600/20 transform -skew-x-12 -translate-x-full group-hover:translate-x-0 transition-transform duration-500"></div>
                  </a>

                  <button
                    className="relative text-white/90 hover:text-white px-5 py-2.5 rounded-xl text-sm font-medium transition-all duration-300 hover:bg-white/10 hover:scale-105 hover:shadow-lg border border-transparent hover:border-white/30 overflow-hidden group"
                    onClick={() => {
                      navigate('/', { state: { scrollTo: 'faq-section' } });
                    }}
                  >
                    <span className="relative z-10">FAQ</span>
                    <div className="absolute inset-0 bg-gradient-to-r from-green-500/20 to-green-600/20 transform -skew-x-12 -translate-x-full group-hover:translate-x-0 transition-transform duration-500"></div>
                  </button>
                  <button
                    className="relative text-white/90 hover:text-white px-5 py-2.5 rounded-xl text-sm font-medium transition-all duration-300 hover:bg-white/10 hover:scale-105 hover:shadow-lg border border-transparent hover:border-white/30 overflow-hidden group"
                    onClick={() => {
                      handleNavigation('/');
                      setTimeout(() => navigate('/', { state: { scrollTo: 'app-section' } }), 0);
                    }}
                  >
                    <span className="relative z-10">App</span>
                    <div className="absolute inset-0 bg-gradient-to-r from-green-500/20 to-green-600/20 transform -skew-x-12 -translate-x-full group-hover:translate-x-0 transition-transform duration-500"></div>
                  </button>
                  <button
                    className="relative text-white/90 hover:text-white px-5 py-2.5 rounded-xl text-sm font-medium transition-all duration-300 hover:bg-white/10 hover:scale-105 hover:shadow-lg border border-transparent hover:border-white/30 overflow-hidden group"
                    onClick={() => {
                      navigate('/', { state: { scrollTo: 'contact-section' } });
                    }}
                  >
                    <span className="relative z-10">Contact</span>
                    <div className="absolute inset-0 bg-gradient-to-r from-green-500/20 to-green-600/20 transform -skew-x-12 -translate-x-full group-hover:translate-x-0 transition-transform duration-500"></div>
                  </button>
                  <button
                    className="relative text-white/90 hover:text-white px-5 py-2.5 rounded-xl text-sm font-medium transition-all duration-300 hover:bg-white/10 hover:scale-105 hover:shadow-lg border border-transparent hover:border-white/30 overflow-hidden group"
                    onClick={() => navigate('/map')}
                  >
                    <span className="relative z-10">Map</span>
                    <div className="absolute inset-0 bg-gradient-to-r from-green-500/20 to-green-600/20 transform -skew-x-12 -translate-x-full group-hover:translate-x-0 transition-transform duration-500"></div>
                  </button>

                  {config.features.enableLogin && (
                    <button
                      className="relative text-white/90 hover:text-white px-5 py-2.5 rounded-xl text-sm font-medium transition-all duration-300 hover:bg-white/10 hover:scale-105 hover:shadow-lg border border-transparent hover:border-white/30 overflow-hidden group"
                      onClick={() => {
                        navigate('/login');
                      }}
                    >
                      <span className="relative z-10">Login</span>
                      <div className="absolute inset-0 bg-gradient-to-r from-green-500/20 to-green-600/20 transform -skew-x-12 -translate-x-full group-hover:translate-x-0 transition-transform duration-500"></div>
                    </button>
                  )}
                </div>

                {/* Contact Info */}
                <div className="flex items-center gap-3">
                  <div className="relative group">
                    <div className="flex items-center gap-3 bg-gradient-to-r from-green-500/20 to-green-600/20 px-5 py-2.5 rounded-2xl border border-green-500/30 backdrop-blur-sm transition-all duration-300 hover:scale-105 hover:shadow-xl hover:shadow-green-500/20">
                      <div className="relative">
                        <IoIosCall className="text-green-400 text-xl group-hover:text-green-300 transition-colors duration-300" />
                        <div className="absolute inset-0 bg-green-400/20 rounded-full blur-md group-hover:bg-green-300/30 transition-colors duration-300"></div>
                      </div>
                      <span className="text-white font-medium text-sm tracking-wide">
                        +977 9801138780
                      </span>
                    </div>
                    <div className="absolute -inset-1 bg-gradient-to-r from-green-500/30 to-green-600/30 rounded-2xl blur-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Mobile Header - Hamburger Menu */}
          <div className="sm:hidden sticky top-0 z-50">
            {/* Mobile Top Bar */}
            <div className="bg-gradient-to-r from-black/80 via-black/60 to-black/80 backdrop-blur-xl border-b border-white/20 shadow-2xl transition-all duration-500">
              <div className="px-4 py-4">
                <div className="flex justify-between items-center">
                  {/* Logo */}
                  <div className="flex items-center gap-2 cursor-pointer" onClick={() => { navigate('/'); setIsMenuOpen(false); }}>
                    <div className="w-12 h-12">
                      <img src={img} alt="kahaLogo" className="w-full h-full object-contain" />
                    </div>
                    <div className="text-[#16A951] font-bold text-lg">
                      KAHA
                    </div>
                  </div>

                  {/* Contact and Hamburger */}
                  <div className="flex items-center gap-3">
                    {/* Contact Info on Mobile */}
                    <div className="relative group">
                      <div className="flex gap-2 items-center text-xs bg-gradient-to-r from-green-500/20 to-green-600/20 px-3 py-2 rounded-xl border border-green-500/30 backdrop-blur-sm transition-all duration-300 hover:scale-105">
                        <div className="relative">
                          <IoIosCall className="text-green-400 group-hover:text-green-300 transition-colors duration-300" />
                          <div className="absolute inset-0 bg-green-400/20 rounded-full blur-sm group-hover:bg-green-300/30 transition-colors duration-300"></div>
                        </div>
                        <span className="text-white font-medium">+977...</span>
                      </div>
                      <div className="absolute -inset-1 bg-gradient-to-r from-green-500/30 to-green-600/30 rounded-xl blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    </div>

                    {/* Hamburger Menu Button */}
                    <button
                      className="relative flex flex-col justify-center items-center w-10 h-10 rounded-xl bg-white/10 backdrop-blur-sm border border-white/20 hover:bg-white/20 transition-all duration-300 hover:scale-105 group"
                      onClick={toggleMenu}
                    >
                      <span className={`bg-white block transition-all duration-300 ease-out h-0.5 w-6 rounded-sm ${isMenuOpen ? 'rotate-45 translate-y-1.5' : '-translate-y-0.5'}`}></span>
                      <span className={`bg-white block transition-all duration-300 ease-out h-0.5 w-6 rounded-sm my-0.5 ${isMenuOpen ? 'opacity-0' : 'opacity-100'}`}></span>
                      <span className={`bg-white block transition-all duration-300 ease-out h-0.5 w-6 rounded-sm ${isMenuOpen ? '-rotate-45 -translate-y-1.5' : 'translate-y-0.5'}`}></span>
                      <div className="absolute inset-0 bg-gradient-to-r from-green-500/20 to-green-600/20 rounded-xl blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Mobile Navigation Menu - Expanded */}
            {isMenuOpen && (
              <div className="bg-gradient-to-b from-black/90 to-black/80 backdrop-blur-xl border-b border-white/20 shadow-2xl">
                <div className="px-4 py-6">
                  <div className="flex flex-col gap-3">
                    <button
                      className="relative text-white bg-gradient-to-r from-green-500/80 to-green-600/80 px-4 py-3 rounded-xl hover:from-green-500/90 hover:to-green-600/90 font-semibold text-left transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-green-500/30 border border-green-500/30 overflow-hidden group"
                      onClick={() => { navigate("/about-us"); setIsMenuOpen(false); }}
                    >
                      <span className="relative z-10">About Us</span>
                      <div className="absolute inset-0 bg-gradient-to-r from-green-400/30 to-green-500/30 transform -skew-x-12 -translate-x-full group-hover:translate-x-0 transition-transform duration-500"></div>
                    </button>

                    <a
                      href={sampadaUrl}
                      target="_self"
                      rel="noopener"
                      className="relative text-white bg-gradient-to-r from-green-500/80 to-green-600/80 px-4 py-3 rounded-xl hover:from-green-500/90 hover:to-green-600/90 font-semibold text-left transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-green-500/30 border border-green-500/30 overflow-hidden group block"
                    >
                      <span className="relative z-10">Sampada</span>
                      <div className="absolute inset-0 bg-gradient-to-r from-green-400/30 to-green-500/30 transform -skew-x-12 -translate-x-full group-hover:translate-x-0 transition-transform duration-500"></div>
                    </a>

                    {[
                      { label: "FAQ", onClick: () => { navigate('/', { state: { scrollTo: 'faq-section' } }); setIsMenuOpen(false); } },
                      { label: "Contact", onClick: () => { navigate('/', { state: { scrollTo: 'contact-section' } }); setIsMenuOpen(false); } },
                      { label: "Map", onClick: () => { navigate('/map'); setIsMenuOpen(false); } },
                      ...(config.features.enableLogin ? [{ label: "Login", onClick: () => { navigate('/login'); setIsMenuOpen(false); } }] : [])
                    ].map((item, index) => (
                      <button
                        key={item.label}
                        className="relative text-white bg-gradient-to-r from-green-500/80 to-green-600/80 px-4 py-3 rounded-xl hover:from-green-500/90 hover:to-green-600/90 font-semibold text-left transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-green-500/30 border border-green-500/30 overflow-hidden group"
                        onClick={item.onClick}
                      >
                        <span className="relative z-10">{item.label}</span>
                        <div className="absolute inset-0 bg-gradient-to-r from-green-400/30 to-green-500/30 transform -skew-x-12 -translate-x-full group-hover:translate-x-0 transition-transform duration-500"></div>
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        </>
      )}


    </>
  );
};

export default StickyNavHeader;
